var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaffiLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 22,
    viewBox: "0 0 65 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3427_7361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6757 0.546875H0.134766V2.75089C2.57622 1.53016 4.80975 0.756142 7.28205 0.756142H7.69925V21.4535H10.1139V0.756142H10.5311C13.0034 0.756142 15.2369 1.53016 17.6784 2.75089L17.6757 0.546875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4268 21.4535H50.8092V10.2698C52.2023 10.0846 53.6067 9.99898 55.012 10.0135C56.4213 9.99984 57.8298 10.0864 59.2268 10.2724V9.28647C57.8298 9.47256 56.4213 9.55908 55.012 9.54537C53.6068 9.55859 52.2024 9.47297 50.8092 9.28916V0.756142H53.6692C56.1401 0.756142 58.3737 1.53016 60.8165 2.75089V0.546875H48.4268V21.4535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3516 21.4535H36.734V10.2698C38.1266 10.0846 39.5306 9.99898 40.9354 10.0135C42.3452 9.99989 43.7541 10.0864 45.1516 10.2724V9.28647C43.7541 9.47251 42.3452 9.55903 40.9354 9.54537C39.5307 9.55859 38.1267 9.47297 36.734 9.28916V0.756142H39.5926C42.0649 0.756142 44.2985 1.53016 46.7399 2.75089V0.546875H34.3516V21.4535Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8815 0.546875H62.499V21.4535H64.8815V0.546875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4862 0.546875L23.2911 2.64492L18.2808 14.1439L15.1592 21.4535H16.3075L19.4196 14.1439L19.4599 14.0513L19.5578 14.0232C20.8488 13.8695 22.148 13.7947 23.448 13.7991C24.7118 13.791 25.9749 13.8568 27.231 13.9963H27.2658H27.3249C27.431 14.0092 27.5359 14.0303 27.6388 14.0594L28.2692 15.7134L28.6596 16.7383L29.6161 19.2455L30.4518 21.4535H32.8396L24.8673 0.546875H22.4862ZM19.8127 13.2478L23.8585 3.96491L27.3222 13.221C26.0375 13.368 24.7451 13.4361 23.4521 13.4249C22.2364 13.4433 21.0208 13.3837 19.8127 13.2465",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_7361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.7468,
    height: 20.9066,
    fill: "white",
    transform: "translate(0.134766 0.546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaffiLogoWhite);
export default __webpack_public_path__ + "static/media/Taffi_Logo_white.8a80588ae71aa82380a0e4c8e850bb78.svg";
export { ForwardRef as ReactComponent };